const appSearch = {
  namespaced: true,
  state: {
    keywordsList: JSON.parse(localStorage.getItem('keywordsList')) || [],
    // 高级搜索条件
    advancedSearchCondition: null,
  },
  getters: {
    keywordsList: (state) => state.keywordsList.slice(0, 5),
    advancedSearchCondition: (state) => state.advancedSearchCondition,
  },
  mutations: {
    SET_KEYWORDS_LIST: (state, keywordsList) => {
      state.keywordsList = keywordsList
      localStorage.setItem('keywordsList', JSON.stringify(keywordsList))
    },
    SET_ADVANCED_SEARCH_CONDITION: (state, advancedSearchCondition) => {
      state.advancedSearchCondition = advancedSearchCondition
    },
  },
  actions: {
    addKeywordsList({ commit, state }, keywords) {
      if (!keywords) return
      const keywordsList = [...state.keywordsList]

      const index = keywordsList.findIndex((item) => item === keywords.trim())
      if (index !== -1) {
        keywordsList.splice(index, 1)
      }
      keywordsList.unshift(keywords)
      commit('SET_KEYWORDS_LIST', keywordsList)
    },
    setKeywordsList({ commit }, keywordsList) {
      commit('SET_KEYWORDS_LIST', keywordsList)
    },
    clearKeywordsList({ commit }) {
      commit('SET_KEYWORDS_LIST', [])
    },
    setAdvancedSearchCondition({ commit }, advancedSearchCondition) {
      commit('SET_ADVANCED_SEARCH_CONDITION', advancedSearchCondition)
    },
    clearAdvancedSearchCondition({ commit }) {
      commit('SET_ADVANCED_SEARCH_CONDITION', null)
    },
  },
}

export default appSearch
